import { Container } from "@mui/material";
import { ReactNode } from "react";

/**
 * The page frame around a team report — shared with the print harness stories
 * so they lay out at the width the app does.
 *
 * `fullPrintWidth`: drop the frame's right padding in print (the ownership
 * postgame report). Its 24px came out of the printable width, and the
 * narrower layout was what pushed that report onto a third sheet.
 */
export default function ReportFrame({
  children,
  fullPrintWidth = false,
}: {
  children: ReactNode;
  fullPrintWidth?: boolean;
}) {
  return (
    <Container
      maxWidth="xl"
      sx={{
        backgroundColor: "white",
        maxWidth: "100%",
        position: "relative",
        zIndex: 0,
        marginTop: "0px !important",
        pl: "0px !important",
        ...(fullPrintWidth && { "@media print": { pr: "0px !important" } }),
      }}
    >
      {children}
    </Container>
  );
}
